import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { TabHeadingDirective } from 'ngx-bootstrap/tabs/public_api';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Report } from '../partner/lab-dashboard/lab-dashboard.component';

@Component({
  selector: 'app-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.css']
})
export class PatientComponent implements OnInit,OnDestroy {

  constructor(private auth:AuthService,public datepipe: DatePipe,private toaster:ToastrService,private router:Router ) { }
  reports:any=[]
  historySubscription:Subscription
  doctorBookings:any=[]
  hospitalBookings:any=[]
  monthArray = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
  imageUrlArray:any=[]
  report=<Report>{}
  showImage:boolean=false
  loginData:any=JSON.parse(localStorage.getItem('logindata'))
  ngOnInit() {
    this.getUserHistory()
    this.getUserDetail()
  }
  getUserDetail(){
    this.auth.getUserDetail().subscribe(res=>{
      this.loginData = res["data"]
      localStorage.setItem('logindata',JSON.stringify(res["data"]))
      this.reports = this.loginData.documents
     

    },error=>{
      console.log(error)
    })
  }
  getUserHistory(){
   this.historySubscription = this.auth.getUserHistory().subscribe(res=>{
      console.log(res)
      this.doctorBookings = res["data"]["doctorBookings"]
      this.doctorBookings.map(booking=>{
        // booking.dateTime=new Date(booking.bookingDate)
         booking.date = booking.bookingDate.split('-')[0]
         booking.year = booking.bookingDate.split('-')[2]
         booking.month = this.monthArray[parseInt(booking.bookingDate.split('-')[1])-1]
       })

       this.hospitalBookings = res["data"]["hospitalBookings"]
       this.hospitalBookings.map(booking=>{
        // booking.dateTime=new Date(booking.bookingDate)
         booking.date = booking.bookingDate.split('-')[0]
         booking.year = booking.bookingDate.split('-')[2]
         booking.month = this.monthArray[parseInt(booking.bookingDate.split('-')[1])-1]
       })
        
     
      // res["data"]["labBookings"].map(labBooking=>{
      
      // this.reports.push(...labBooking.reports.filter(report=>report!=''))
      // })

   
  

},
error=>{

})

  }
  openImage(report){
    this.imageUrlArray=[]
    this.imageUrlArray.push(report)
    document.getElementById('orderImagesCLick').click()
  }
  deleteRecord(i,singleReport){
  
  this.auth.deleteReport(singleReport).subscribe(res=>{
    this.reports.splice(i,1)
    this.toaster.success('Record Deleted Successfully..', 'Success',{
      timeOut: 2000
    });
    this.loginData.documents = this.reports
    localStorage.setItem('logindata',JSON.stringify(this.loginData))
  },
  error=>{
    this.toaster.error(error.error.message, 'Error',{
      timeOut: 2000
    });
  })
  }
  updateDocuments(){
    this.reports.push(this.report)
    console.log(this.reports)
    this.auth.documentsUpdate(this.reports,this.loginData.name).subscribe(res=>{
      this.toaster.success('Record Uploaded Successfully..', 'Success',{
        timeOut: 2000
      });
      this.loginData.documents = this.reports
      localStorage.setItem('logindata',JSON.stringify(this.loginData))
      document.getElementById('uploadReportClick').click()
    },
    error=>{
      this.reports.splice(this.reports.length-1,1)
      this.toaster.error('There was some error...', 'Error',{
        timeOut: 2000
      });
    })
  }
  openRecordPopup(){
    this.showImage=false
    this.report = <Report>{}
  }
  fileChanged(event) {
    if(event.target.files.length){
      console.log(event.target.files[0])
      if(event.target.files[0].type=='application/pdf'){
        this.auth.pdfFileUpload(event.target.files[0]).subscribe(res => {
          this.showImage = true
     
            this.report.image  = res["data"]["original"]
         
          
               
         // this.uploadReport( booking.reports,booking)
        },
        error => {
          console.log(error)
          this.toaster.error('There was some error.uploading the report..', 'Error',{
            timeOut: 2000
          });
        })
      }
      else{
    this.auth.fileUpload(event.target.files[0]).subscribe(res => {
      this.showImage = true
       
        this.report.image = res["data"]["original"]
 
      
           
     // this.uploadReport( booking.reports,booking)
    },
    error => {
      console.log(error)
      this.toaster.error('There was some error.uploading the report..', 'Error',{
        timeOut: 2000
      });
    })
  }
  }
  else{
    this.toaster.error('Please select a report Upload..', 'Error',{
      timeOut: 2000
    });
  }

  }
  convertTime (time) {
    //  let time = this.datepipe.transform(createdAt,'HH:mm')
    //  console.log(time)
     
      // Check correct time format and split into components
    
      let time1 = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    let time2:any
    
      if (time1.length>1) { // If time format correct
         time2 = time1.slice (1);  // Remove full string match value
        time2[5] = +time2[0] < 12 ? ' am' : ' pm'; // Set AM/PM
        time2[0] = +time2[0] % 12 || 12; // Adjust hours
      }
      else{
    
      }
      //console.log(time2)
     return  time2.join ('') // return adjusted time or original string
    }
   toggle(id) {
    var x = document.getElementById("prcritpins-hidden-cnt-"+id);
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  }
  toggleHospital(id) {
    var x = document.getElementById("prcritpins-hidden-cnt-hsp-"+id);
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  }
  ngOnDestroy(): void {
   this.historySubscription.unsubscribe()
    
  }

}
